import React, { createContext, useContext, useState } from 'react';

export const UIContext = createContext();

export function UIProvider({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [overlay, setOverlay] = useState(null); // { type, props }
  const [toast, setToast] = useState(null); // { message, type }
  const [loading, setLoading] = useState(false);

  const toggleSidebar = () => setSidebarOpen((prev) => !prev);
  const toggleSidebarCollapse = () => setSidebarCollapsed((prev) => !prev);

  const openOverlay = (type, props) => setOverlay({ type, props });
  const closeOverlay = () => setOverlay(null);

  const showToast = (message, type = 'info') => setToast({ message, type });
  const hideToast = () => setToast(null);

  /**
   * Reset completo dello stato UI
   * Da chiamare al logout per pulizia completa
   */
  const resetUIState = () => {
    console.log('[UIContext] Reset completo stato UI');
    setSidebarOpen(true);
    setSidebarCollapsed(false);
    setOverlay(null);
    setToast(null);
    setLoading(false);
  };

  return (
    <UIContext.Provider
      value={{
        sidebarOpen,
        setSidebarOpen,
        toggleSidebar,
        sidebarCollapsed,
        setSidebarCollapsed,
        toggleSidebarCollapse,
        overlay,
        openOverlay,
        closeOverlay,
        toast,
        showToast,
        hideToast,
        loading,
        setLoading,
        resetUIState,
      }}
    >
      {children}
    </UIContext.Provider>
  );
}

export function useUI() {
  return useContext(UIContext);
}
